import React, { useState } from 'react';
import { Component } from 'react';
import queryString from 'query-string';
import CustomerDashboardQuickLinks from '../../components/CustomerDashboard/CustomerDashboardQuickLinks';
import UserService from '../../services/UserService';
import OrderGatewayCustomerPage from "./OrderGatewayCustomerPage";

export default class MyOrders extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: "",       // could be --> "submitted","completed","cancelled"
            searchParams: {},
            user: {}
        };
        this.userService = new UserService();
    }

    componentDidMount() {
        let { activeTab } = this.state;
        let user = this.userService.getLoggedInUser();
        if (this.props.location.search) {
            let searchParams = queryString.parse(this.props.location.search);
            activeTab = searchParams.activeTab ? searchParams.activeTab : '';
            this.setState({ activeTab, searchParams,user });
        } else {
            this.setState({ activeTab: "submitted",user });
        }
    }


    render() {
        let { activeTab,user } = this.state;

        return (
            <div>
                <div className="text-center">
                    {user && user.menu && user.menu.role === 'ExternalUser' ?
                        <CustomerDashboardQuickLinks size={"sm"} /> : null}
                    <hr />
                </div>
                {
                    (activeTab !== null && activeTab !== undefined && activeTab !== "")
                        ?
                        <div className="my-order-layout">
                            <OrderGatewayCustomerPage activeTab={this.state.activeTab} />
                        </div>
                        :
                        null
                }
            </div>
        );
    }
}